/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { login } from '../../services';
import { setCookie } from '../../helper/lib';
import { useDispatch } from 'react-redux';
import { changeDataProfile, changeLoading, changeMode } from '../../store';
import { requestPermission, requestFirebaseToken } from '../../helper/firebase';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import MicroModal from 'micromodal';
import SimpleModal from '../../organism/MicroModal/SimpleModal';
import Logo from '../../assets/img/logo_kisahruang.png';
import InfoDanger from '../../assets/img/custom/info-danger.svg';

MicroModal.init();

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userAgent = navigator.userAgent;
  const touchPoint = navigator.maxTouchPoints;

  const [showPassword, setShowPassword] = useState(false);
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required.')
      .email('Please enter a valid email address.'),
    password: Yup.string().required('Password is required.'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const [errorMessage, seterrorMessage] = React.useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOptions);

  const onSubmit = async (data) => {
    try {
      dispatch(changeLoading(true));
      const payload = {
        ...data,
        device_model: 'linux',
        device_type: 'WEB',
        device_id: localStorage.getItem('firebase_token'),
      };
      const response = await login(payload);
      if (response && response.data && response.message === 'Success') {
        setCookie(
          'token',
          response.data.access_token,
          response.data.expired_date
        );

        dispatch(changeDataProfile(response.data.profile_data));

        const merchantType =
          response?.data?.profile_data?.merchant_type.toLowerCase();

        toast.success('Login Success', {
          position: 'top-right',
          autoClose: 2000,
        });

        // if (
        //   response.data.profile_data &&
        //   !response.data.profile_data.is_complete_profile
        // ) {
        //   navigate('/fill-profile-form');
        //   return;
        // }

        if (merchantType === 'vendor' || merchantType === 'vendor + designer') {
          dispatch(changeMode('vendor'));

          navigate('/');
          return;
        }

        dispatch(changeMode('designer'));
        navigate('/');
      }
    } catch (error) {
      seterrorMessage(error?.response?.data?.message ?? 'Something went wrong');
      toast.error(error?.response?.data?.message ?? 'Something went wrong');
    } finally {
      dispatch(changeLoading(false));
    }
  };

  const handlePermissionModal = (status) => {
    if (status === 'open') {
      MicroModal.show('ask-permission-modal');
      return;
    }
    MicroModal.close('ask-permission-modal');
  };

  const handleInfoPermissionModal = (status) => {
    if (status === 'open') {
      MicroModal.show('info-permission-modal');
      return;
    }
    MicroModal.close('info-permission-modal');
  };

  const handleNotification = () => {
    requestPermission();
    handlePermissionModal('close');
  };

  dispatch(changeMode(null));

  useEffect(() => {
    localStorage.clear();

    if (
      userAgent.includes('Macintosh') &&
      userAgent.includes('Safari') &&
      userAgent.includes('Mozilla')
    ) {
      if (
        userAgent.includes('Chrome') ||
        userAgent.includes('Edge') ||
        userAgent.includes('Opera')
      ) {
        if (touchPoint > 0) {
          return;
        }

        if (Notification.permission === 'granted') {
          requestFirebaseToken();
          return;
        }

        requestPermission();
        return;
      }

      if (touchPoint > 0) {
        return;
      }

      if (Notification.permission === 'granted') {
        requestFirebaseToken();
        return;
      }

      if (Notification.permission === 'denied') {
        handleInfoPermissionModal('open');
        return;
      }

      handlePermissionModal('open');
      return;
    }

    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      return;
    }

    requestPermission();
  }, []);

  return (
    <>
      <SimpleModal id={'ask-permission-modal'}>
        <div className="ask-permission-modal__container">
          <h2 className="ask-permission-modal__title">Notification</h2>
          <div className="w-100 mt-3">
            <p className="ask-permission-modal__text-content">
              We need grant access to your notifications to notify you about the
              orders
            </p>
          </div>
          <div className="w-100 mt-3">
            <button
              type="button"
              className="ask-permission-modal__btn allow"
              onClick={handleNotification}
            >
              Request
            </button>
            <button
              type="button"
              className="ask-permission-modal__btn not-allow"
              onClick={() => handlePermissionModal('close')}
            >
              Don't Allow
            </button>
          </div>
        </div>
      </SimpleModal>
      <SimpleModal id={'info-permission-modal'}>
        <div className="ask-permission-modal__container">
          <h2 className="ask-permission-modal__title">Notification</h2>
          <div className="w-100 mt-4">
            <p className="ask-permission-modal__text-content">
              Please check your browser settings to enable notifications
            </p>
          </div>
          <div className="w-100 mt-4">
            <button
              type="button"
              className="ask-permission-modal__btn allow"
              onClick={() => handleInfoPermissionModal('close')}
            >
              Close
            </button>
          </div>
        </div>
      </SimpleModal>
      <div className="wrap-content signin">
        <div className="row h-100">
          <div className="col-12 h-100 position-relative form-parent">
            <div className="d-flex align-items-center justify-content-center form-wrap px-5 px-md-0">
              <form method="post" onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex align-items-center justify-content-center mb-3 head">
                  <div className="login--logo-container">
                    <img src={Logo} alt="img-logo" />
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <span className="pe-1 text-gray fs-3 text-center fw-bold">
                    Welcome Back!
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-center mb-5">
                  <span className="pe-1 text-gray text-center fz-14">
                    Enter your email and password below to log in.
                  </span>
                </div>
                <div className="mb-3">
                  <label className="form-label fz-12 fw-bold">Email</label>
                  <input
                    className="form-control border-input-default"
                    {...register('email', {
                      required: true,
                      pattern: /^\S+@\S+$/i,
                    })}
                    type="text"
                    autocomplete="off"
                  />
                  {errors.email && (
                    <div className="invalid-field">{errors.email?.message}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label fz-12 fw-bold">Password</label>.
                  <div className="d-flex border bg-white rounded password">
                    <input
                      {...register('password')}
                      className="form-control border-0"
                      type={showPassword ? 'text' : 'password'}
                      aria-label="password"
                      aria-describedby="basic-addon1"
                      autocomplete="off"
                    />
                    <span
                      className="input-group-text bg-white border-0"
                      id="basic-addon1"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaEyeSlash className="text-secondary" />
                      ) : (
                        <FaEye className="text-secondary" />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <div className="invalid-field">
                      {errors.password?.message}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <Link
                    to="/forgot-password"
                    className="link-dark fz-14 fw-semibold"
                  >
                    Forgot your password?
                  </Link>
                </div>
                {errorMessage && (
                  <div
                    className="text-danger alert alert-danger d-flex align-items-center py-2 border-0"
                    role="alert"
                  >
                    <img
                      src={InfoDanger}
                      style={{ width: '23px' }}
                      alt="warning"
                    />
                    <div className="fz-14 ps-2">{errorMessage}</div>
                  </div>
                )}
                <button
                  type="submit"
                  className="btn w-100 fw-semibold btn-fill"
                >
                  Login
                </button>
                <div className="d-flex align-items-center justify-content-center mt-3 fz-14 ask">
                  <span className="pe-1">Don't have an account?</span>
                  <span className="">
                    <Link to="/register" className="link-dark fw-semibold">
                      Sign Up
                    </Link>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
